module.exports = __webpack_public_path__ + "img/icon_comments_2.6a1876d9.png";